"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CalendarTimeOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M25.89,24.45A1,1,0,0,1,25,25a.93.93,0,0,1-.45-.11L22,23.62V21a1,1,0,0,1,2,0v1.38l1.45.73A1,1,0,0,1,25.89,24.45Z"/><path d="M26,16.68h0V7a3,3,0,0,0-3-3H22V3a1,1,0,0,0-2,0V4H8V3A1,1,0,0,0,6,3V4H5A3,3,0,0,0,2,7V23a3,3,0,0,0,3,3H16.68A7,7,0,1,0,26,16.68ZM4,7A1,1,0,0,1,5,6H6V8A1,1,0,0,0,8,8V6H20V8a1,1,0,0,0,2,0V6h1a1,1,0,0,1,1,1v4H4ZM5,24a1,1,0,0,1-1-1V13H24v3.08A6.63,6.63,0,0,0,23,16a7,7,0,0,0-7,7,6.63,6.63,0,0,0,.08,1Zm18,4a5,5,0,1,1,5-5A5,5,0,0,1,23,28Z"/>';
var CalendarTimeOutlineSVG = function CalendarTimeOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.CalendarTimeOutlineSVG = CalendarTimeOutlineSVG;
CalendarTimeOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CalendarTimeOutlineSVG);
exports.default = _default;